import { useDeleteDCompany } from "./api/deleteDCompany";
import { Button } from "reactstrap";


const DeleteDCompany = ({handleCloseModal, dCompanyId}: DeleteDCompanyProps)  => {
  
  const deleteDCompanyMutation = useDeleteDCompany({ dCompanyId});
  const handleSubmit = async (): Promise<void> => {
    deleteDCompanyMutation.mutateAsync({ 
      dCompanyId: dCompanyId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Θυγατρική;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteDCompanyProps{
  dCompanyId: number;
  handleCloseModal: () => void;
}

export default DeleteDCompany;